module.exports = __webpack_public_path__ + "46b350d0da14c5337a6f94cd5d51747c.png";